export default __webpack_public_path__ + "static/media/overflowing.f4fd93b6.png";